import { useNavigate } from "react-router-dom";
import { PHONE_DISPLAY, BRAND, TAGLINE, waDefault } from "@/lib/api";
import { scrollToHash } from "@/components/Navbar";

const Footer = () => {
  const navigate = useNavigate();
  const go = (to) => (e) => {
    e.preventDefault();
    if (to.startsWith("/#")) {
      const hash = to.slice(2);
      if (window.location.pathname !== "/") {
        navigate("/");
        setTimeout(() => scrollToHash(hash), 450);
      } else scrollToHash(hash);
    } else navigate(to);
  };

  return (
    <footer className="border-t border-gold/15 bg-ink2">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3 md:px-8">
        <div>
          <img src="/logo.jpg" alt={BRAND} className="h-16 w-auto" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-stone2">{TAGLINE}. Venta y alquiler de propiedades con atención directa y personal.</p>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-subtle">Enlaces</p>
          <ul className="mt-5 space-y-3 text-sm text-ivory/80">
            <li><a href="/propiedades" onClick={go("/propiedades")} data-testid="footer-link-properties" className="hover:text-gold">Propiedades</a></li>
            <li><a href="/busca-tu-piso" onClick={go("/busca-tu-piso")} data-testid="footer-link-ficha" className="hover:text-gold">Busca tu piso (ficha cliente)</a></li>
            <li><a href="/visitas" onClick={go("/visitas")} data-testid="footer-link-visitas" className="hover:text-gold">Visitas sin presencia</a></li>
            <li><a href="/#nosotros" onClick={go("/#nosotros")} data-testid="footer-link-about" className="hover:text-gold">Nosotros</a></li>
            <li><a href="/#contacto" onClick={go("/#contacto")} data-testid="footer-link-contact" className="hover:text-gold">Contacto</a></li>
            <li><a href="/admin" onClick={go("/admin")} data-testid="footer-link-admin" className="text-stone2 hover:text-gold">Panel de administración</a></li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-subtle">Legal</p>
          <ul className="mt-5 space-y-3 text-sm text-ivory/80">
            <li><a href="/legal/aviso-legal" onClick={go("/legal/aviso-legal")} data-testid="footer-legal-aviso-legal" className="hover:text-gold">Aviso legal</a></li>
            <li><a href="/legal/privacidad" onClick={go("/legal/privacidad")} data-testid="footer-legal-privacidad" className="hover:text-gold">Política de privacidad (RGPD)</a></li>
            <li><a href="/legal/cookies" onClick={go("/legal/cookies")} data-testid="footer-legal-cookies" className="hover:text-gold">Política de cookies</a></li>
          </ul>
          <p className="mt-6 text-sm text-stone2">
            WhatsApp y teléfono: <span className="text-gold">{PHONE_DISPLAY}</span>
          </p>
        </div>
      </div>
      <div className="border-t border-gold/10 py-6 text-center text-xs text-stone2">
        © {new Date().getFullYear()} {BRAND}. Todos los derechos reservados. · Escríbenos por{" "}
        <a href={waDefault()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="text-wa hover:underline">
          WhatsApp
        </a>
      </div>
    </footer>
  );
};

export default Footer;
